import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Icon, Stack, Toast, Toaster } from '@chakra-ui/react';
import { ToastType, toaster } from '@client/toaster';
import { FaCheckCircle, FaExclamationCircle, FaInfoCircle, } from 'react-icons/fa';
export const AppToaster = () => {
    return (_jsx(Toaster, { toaster: toaster, children: (toast) => {
            const iconType = getToastIcon(toast.type);
            return (_jsx(Toast.Root, { maxW: "90vw", w: "auto", px: 5, py: 2.5, borderRadius: 5, background: toast.type === ToastType.Success
                    ? 'green.success'
                    : toast.type === ToastType.Error
                        ? 'red.error'
                        : 'white', color: toast.type === ToastType.Success ||
                    toast.type === ToastType.Error
                    ? 'white'
                    : 'black', children: _jsxs(Flex, { gap: 4, alignItems: "center", children: [iconType && (_jsx(Icon, { as: iconType, h: 22, w: 22 })), _jsxs(Stack, { gap: 1, minW: 0, flex: "1", children: [_jsx(Toast.Title, { fontSize: 20, wordBreak: "break-word", children: toast.title }), _jsx(Toast.Description, { fontSize: 18, wordBreak: "break-word", children: toast.description })] }), toast.action && (_jsx(Toast.ActionTrigger, { cursor: "pointer", whiteSpace: "nowrap", fontSize: 16, border: "1px solid", children: toast.action.label }))] }) }));
        } }));
};
const getToastIcon = (type) => {
    if (type === ToastType.Success)
        return FaCheckCircle;
    if (type === ToastType.Error)
        return FaExclamationCircle;
    if (type === ToastType.Info)
        return FaInfoCircle;
    return null;
};
